<div [ngClass]="cardStyles()" class="p-2">
  @if (showTitle()) {
    <h3 class="h4 pb-2 fw-bold" *scText="title()!"></h3>
  }
  <div class="d-flex flex-column gap-2">
    <div class="d-flex gap-2 align-items-center">
      <div
        class="review__score fw-bold d-flex justify-content-center align-items-center h4 text-white p-4 mb-1"
        aria-hidden="true"
      >
        {{ stats().averageRating }}
      </div>
      <wl-review-stars
        class="text-nowrap mb-1"
        [score]="stats().averageRating"
        [a11yText]="
          'reviewsFeature.a11y.averageScore'
            | translate: { brand: brand, rating: stats().averageRating }
        "
      />
    </div>

    <ng-container *ngTemplateOutlet="reviewAndRecommendation" />

    @if (type() !== 'overview' && showButton()) {
      <div>
        <crnt-button-alt variant="secondary" class="d-block d-md-inline-block">
          <a *wlGenericLink="button()"></a>
        </crnt-button-alt>
      </div>
    }

    <ng-container *ngTemplateOutlet="klantenvertellenlogo" />
  </div>
</div>

<ng-template #klantenvertellenlogo>
  <img
    [class]="'review__klanten-vertellen-logo__' + logoSize()"
    [src]="'assets/klantenvertellen-logo.svg' | deployUrl"
    alt="Klanten vertellen logo"
    loading="lazy"
  />
</ng-template>

<ng-template #reviewAndRecommendation>
  <div>
    <div class="d-flex align-items-center mb-1">
      <crnt-icon
        icon="check"
        size="large"
        class="text-success me-1 align-self-start"
      />
      <span>
        <strong>{{ stats().totalReviews }}&nbsp;</strong>
        {{ 'reviewsFeature.totalReviewsText' | translate }}
      </span>
    </div>
    <div class="d-flex align-items-center">
      <crnt-icon
        icon="check"
        size="large"
        class="text-success me-1 align-self-start"
      />
      <span>
        <strong>{{ stats().recommendPercentage }}%&nbsp;</strong>
        {{ 'reviewsFeature.recommendationText' | translate: { brand: brand } }}
      </span>
    </div>
  </div>
</ng-template>
